import { 
  Code2, 
  Globe, 
  Mail, 
  TrendingUp, 
  Smartphone, 
  Users, 
  Building2, 
  ShoppingCart, 
  GraduationCap, 
  Heart, 
  Award, 
  Shield, 
  Lightbulb, 
  ArrowRight, 
  Menu, 
  X, 
  Star, 
  CheckCircle, 
  Bolt,
  Phone,
  MapPin,
  Zap,
  Target,
  Rocket,
  Sparkles,
  Layers,
  Cpu,
  Database,
  Cloud,
  Lock,
  Eye,
  BarChart3,
  Settings,
  Palette,
  Monitor,
  Server,
  Network,
  Wifi,
  Activity,
  PieChart,
  LineChart,
  DollarSign,
  CreditCard,
  ShieldCheck,
  UserCheck,
  MessageSquare,
  Video,
  Camera,
  Mic,
  Headphones,
  Printer,
  Keyboard,
  Mouse,
  MonitorSmartphone,
  Tablet,
  Watch,
  Tv,
  Projector,
  Speaker,
  Volume2,
  VolumeX,
  Volume1,
  Play,
  Pause,
  SkipBack,
  SkipForward,
  Rewind,
  FastForward,
  RotateCcw,
  RotateCw,
  Shuffle,
  Repeat,
  Volume,
  Maximize,
  Minimize,
  Maximize2,
  Minimize2,
  Move,
  MoveHorizontal,
  MoveVertical,
  ZoomIn,
  ZoomOut,
  Search,
  SearchX,
  Filter,
  FilterX,
  SortAsc,
  SortDesc,
  Grid,
  List,
  Columns,
  Rows,
  Layout,
  LayoutGrid,
  LayoutList,
  Sidebar,
  SidebarClose,
  SidebarOpen,
  PanelLeft,
  PanelRight,
  PanelTop,
  PanelBottom,
  PanelLeftClose,
  PanelRightClose,
  PanelTopClose,
  PanelBottomClose,
  PanelLeftOpen,
  PanelRightOpen,
  PanelTopOpen,
  PanelBottomOpen,
  Split,
  SplitSquareHorizontal,
  SplitSquareVertical,

} from 'lucide-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useState } from "react";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import emailjs from '@emailjs/browser';

const Index = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProjectFormOpen, setIsProjectFormOpen] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const handleFormSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setIsSending(true);

    try {
      const formData = new FormData(e.currentTarget);
      const templateParams = {
        to_email: 'belednai24@gmail.com',
        from_name: formData.get('name'),
        from_email: formData.get('email'),
        phone_number: formData.get('number'),
        message: formData.get('message'),
      };

      await emailjs.send(
        'service_belednai', // Replace with your EmailJS service ID
        'template_belednai', // Replace with your EmailJS template ID
        templateParams,
        'your_public_key' // Replace with your EmailJS public key
      );

      alert('Message sent successfully!');
      setIsProjectFormOpen(false);
    } catch (error) {
      console.error('Error sending email:', error);
      alert('Failed to send message. Please try again.');
    } finally {
      setIsSending(false);
    }
  };

  return (
    <div id="main-content" role="main" className="min-h-screen bg-white">
      {/* Microsoft Fluent Design Header */}
      <header className="ms-nav">
        <div className="ms-container">
          <div className="flex items-center justify-between py-4">
            <div className="flex items-center space-x-4">
              <div className="flex items-center justify-center w-10 h-10">
                <img 
                  src="/logo.png" 
                  alt="Belednai Technology Logo"
                  className="max-h-10 max-w-10 object-contain"
                />
              </div>
              <div>
                <h1 className="ms-text-title ms-gradient-text-primary">Belednai Technology</h1>
                <p className="ms-text-caption">Inventing the Unseen</p>
              </div>
            </div>
            
            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center space-x-2" aria-label="Primary">
              <a href="#services" className="ms-nav-link">Services</a>
              <a href="#solutions" className="ms-nav-link">Solutions</a>
              <a href="#about" className="ms-nav-link">About</a>
              <a href="#team" className="ms-nav-link">Team</a>
              <a href="#contact" className="ms-nav-link">Contact</a>
            </nav>
            
            <div className="flex items-center space-x-4">
              <button 
                onClick={() => setIsProjectFormOpen(true)}
                className="ms-btn-primary hidden md:flex"
                aria-label="Get started"
              >
                Get Started
                <FontAwesomeIcon icon={["fas","arrow-right"]} className="ml-2 h-4 w-4" />
              </button>
              
              {/* Mobile Menu Button */}
              <button 
                className="lg:hidden p-3 rounded hover:bg-gray-100 transition-colors"
                aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
                onClick={() => setIsMenuOpen(!isMenuOpen)}
              >
                {isMenuOpen ? (
                  <FontAwesomeIcon icon={["fas","times"]} className="h-5 w-5" />
                ) : (
                  <FontAwesomeIcon icon={["fas","bars"]} className="h-5 w-5" />
                )}
              </button>
            </div>
          </div>
          
          {/* Microsoft Mobile Menu */}
          {isMenuOpen && (
            <div className="lg:hidden py-6 border-t border-gray-200 ms-fade-in">
              <nav className="flex flex-col space-y-2">
                <a href="#services" className="ms-nav-link">Services</a>
                <a href="#solutions" className="ms-nav-link">Solutions</a>
                <a href="#about" className="ms-nav-link">About</a>
                <a href="#team" className="ms-nav-link">Team</a>
                <a href="#contact" className="ms-nav-link">Contact</a>
                <button className="ms-btn-primary mt-6 w-full" onClick={() => setIsProjectFormOpen(true)}>
                  Get Started
                </button>
              </nav>
            </div>
          )}
        </div>
      </header>

      {/* Microsoft Fluent Design Hero Section */}
      <section className="ms-hero-bg min-h-screen flex items-center justify-center relative overflow-hidden">
        {/* Video Background */}
        <div className="absolute inset-0 w-full h-full">
          <video
            className="absolute inset-0 w-full h-full object-cover opacity-35"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            poster="/tech-hero-poster.jpg"
          >
            <source src="/new.mp4" type="video/mp4" />
          </video>
        </div>

        {/* Dark Overlay for Better Text Contrast */}
        <div className="absolute inset-0 bg-black/60 z-10"></div>

        {/* Hero Content */}
        <div className="relative z-20 px-4 sm:px-6 lg:px-8 max-w-5xl lg:max-w-6xl mx-auto">
          <div className="text-center ms-glass-card/50 bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl px-6 sm:px-10 lg:px-16 py-10 md:py-14 lg:py-16 shadow-[0_10px_40px_rgba(0,0,0,0.25)]">
            {/* Hero Headlines */}
            <h1 className="ms-slide-up tracking-normal sm:tracking-tight leading-snug sm:leading-tight text-white font-semibold mb-6 text-2xl sm:text-4xl lg:text-6xl">
              <span className="block mb-1 drop-shadow-[0_2px_4px_rgba(0,0,0,0.7)]">Empowering businesses with</span>
              <span className="block font-extrabold drop-shadow-[0_2px_4px_rgba(0,0,0,0.7)]">
                <span className="block sm:inline">innovative technology</span>{' '}
                <span className="block sm:inline">solutions</span>
              </span>
            </h1>

            {/* Hero Subtitle */}
            <p className="ms-fade-in text-white/85 drop-shadow-[0_1px_2px_rgba(0,0,0,0.6)] font-normal leading-relaxed mx-auto max-w-3xl text-sm sm:text-base md:text-xl lg:text-2xl" style={{animationDelay: '0.2s'}}>
              From custom software development to comprehensive digital solutions, we transform your business vision into reality with cutting-edge technology.
            </p>

            {/* Hero Actions */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mt-10 ms-fade-in" style={{animationDelay: '0.3s'}}>
            <button 
              onClick={() => setIsProjectFormOpen(true)}
                className="ms-btn-primary ms-btn-large px-8 py-4 text-lg lg:px-10 lg:py-5 lg:text-xl bg-white text-[#2a2d70] hover:bg-gray-50 border-0 shadow-lg"
            >
              <span className="flex items-center">
                Start Your Project
                <FontAwesomeIcon icon={["fas","arrow-right"]} className="ml-2 h-5 w-5" />
              </span>
            </button>
               <Button 
              onClick={() => {
                const solutionsSection = document.getElementById('solutions');
                if (solutionsSection) {
                  solutionsSection.scrollIntoView({ behavior: 'smooth' });
                }
              }}
                 className="ms-btn-secondary ms-btn-large px-8 py-4 text-lg lg:px-10 lg:py-5 lg:text-xl bg-transparent text-white border-2 border-white/50 hover:bg-white/10 hover:border-white/80"
            >
              <span className="flex items-center">
                View Our Work
                <FontAwesomeIcon icon={["fas","globe"]} className="ml-2 h-5 w-5" />
              </span>
            </Button>
            </div>

            {/* Stats Section - compact for balance */}
            <div className="grid grid-cols-3 gap-4 sm:gap-6 max-w-xl mx-auto mt-10">
              <div className="text-center ms-scale-in">
                <div className="ms-icon mx-auto mb-2 bg-white/15 text-white" aria-hidden="true">
                  <FontAwesomeIcon icon={["fas","star"]} className="h-4 w-4 lg:h-5 lg:w-5" />
                </div>
                <div className="text-lg sm:text-2xl lg:text-3xl font-bold text-white">5.0</div>
                <div className="text-white/80 text-[11px] sm:text-xs uppercase tracking-wide">Client Rating</div>
              </div>

              <div className="text-center ms-scale-in" style={{animationDelay: '0.1s'}}>
                <div className="ms-icon mx-auto mb-2 bg-white/15 text-white" aria-hidden="true">
                  <FontAwesomeIcon icon={["fas","check-circle"]} className="h-4 w-4 lg:h-5 lg:w-5" />
                </div>
                <div className="text-lg sm:text-2xl lg:text-3xl font-bold text-white">50+</div>
                <div className="text-white/80 text-[11px] sm:text-xs uppercase tracking-wide">Projects</div>
              </div>

              <div className="text-center ms-scale-in" style={{animationDelay: '0.2s'}}>
                <div className="ms-icon mx-auto mb-2 bg-white/15 text-white" aria-hidden="true">
                  <FontAwesomeIcon icon={["fas","users"]} className="h-4 w-4 lg:h-5 lg:w-5" />
                </div>
                <div className="text-lg sm:text-2xl lg:text-3xl font-bold text-white">3</div>
                <div className="text-white/80 text-[11px] sm:text-xs uppercase tracking-wide">Experts</div>
              </div>
            </div>
          </div>
        </div>

        {/* Microsoft Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 text-white/60 ms-bounce">
          <div className="flex flex-col items-center">
            <div className="w-px h-8 bg-gradient-to-b from-transparent to-white/40 mb-2"></div>
            <div className="text-xs font-medium">Scroll to explore</div>
          </div>
        </div>
      </section>

      {/* Microsoft Services Section */}
      <section id="services" className="ms-section ms-surface">
        <div className="ms-container">
          <div className="text-center mb-16 ms-fade-in">
            <div className="ms-badge ms-badge-primary mb-6">
                <FontAwesomeIcon icon={["fas","bolt"]} className="h-4 w-4 mr-2" />
              Our Services
            </div>
            <h2 className="ms-text-hero mb-6 ms-gradient-text-primary">
              Comprehensive Technology Solutions
            </h2>
            <p className="ms-text-subtitle max-w-3xl mx-auto">
              We provide end-to-end technology services designed to transform your business 
              and drive sustainable growth in the digital age.
            </p>
          </div>
          
          <div className="ms-grid-3">
            {[
              {
                icon: Globe,
                title: "Website Development",
                description: "Professional, responsive websites that showcase your business and drive conversions",
                features: ["Custom Design", "Mobile Responsive", "SEO Optimized", "Fast Loading"]
              },
              {
                icon: Code2,
                title: "Custom Software",
                description: "Tailored software solutions to streamline operations and boost efficiency",
                features: ["Business Management", "Inventory Systems", "Custom Workflows", "API Integration"]
              },
              {
                icon: Mail,
                title: "Email Solutions",
                description: "Professional email systems that enhance communication and build credibility",
                features: ["Custom Domains", "Secure Hosting", "24/7 Support", "Migration Services"]
              },
              {
                icon: TrendingUp,
                title: "Digital Marketing",
                description: "Strategic marketing campaigns that reach your audience and grow your brand",
                features: ["Social Media", "SEO & SEM", "Analytics", "Content Strategy"]
              },
              {
                icon: Smartphone,
                title: "Mobile Solutions",
                description: "Mobile apps and responsive solutions for the modern, connected world",
                features: ["Native Apps", "Progressive Web Apps", "Cross-Platform", "App Store Optimization"]
              },
              {
                icon: Users,
                title: "IT Consulting",
                description: "Expert guidance to help you make informed technology decisions",
                features: ["Technology Strategy", "System Integration", "Training & Support", "Digital Transformation"]
              }
            ].map((service, index) => (
              <div key={index} className="ms-glass-card p-6 ms-fade-in" style={{animationDelay: `${index * 0.1}s`}}>
                <div className="ms-icon ms-icon-primary mb-6">
                  <service.icon className="h-6 w-6" />
                </div>
                <h3 className="ms-text-title mb-4 ms-gradient-text-primary">{service.title}</h3>
                <p className="ms-text-body mb-6">{service.description}</p>
                <ul className="space-y-3">
                  {service.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="flex items-center ms-text-body">
                      <CheckCircle className="h-4 w-4 text-[#2a2d70] mr-3 flex-shrink-0" />
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Microsoft Solutions Section */}
      <section id="solutions" className="ms-section ms-surface-1">
        <div className="ms-container">
          <div className="text-center mb-16 ms-fade-in">
              <div className="ms-badge ms-badge-primary mb-6">
                <FontAwesomeIcon icon={["fas","award"]} className="h-4 w-4 mr-2" />
              Success Stories
            </div>
            <h2 className="ms-text-hero mb-6 ms-gradient-text-secondary">
              Transforming Businesses Across South Sudan
            </h2>
            <p className="ms-text-subtitle max-w-3xl mx-auto">
              Discover how we've helped organizations achieve digital transformation 
              and drive measurable results through innovative technology solutions.
            </p>
          </div>
          
          <div className="ms-grid-3">
            {[
              {
                image: "/images/electo.png",
                title: "Electo Election System",
                description: "Complete digital voting and counting system for elections",
                metrics: ["3 iPads + Computer", "Real-time Counting", "Starlink WiFi"]
              },
              {
                image: "/images/wifi-ticketing.svg",
                title: "Wipay WiFi Ticketing",
                description: "WiFi reseller app for token generation and sales analytics",
                metrics: ["Token Generation", "Daily/Monthly Reports", "User Management"]
              },
              {
                image: "/images/hr-management.svg",
                title: "HR Management System",
                description: "Complete human resources platform for employee management and payroll",
                metrics: ["Payslip Generation", "Employee Profiles", "Hiring Process", "Staff Learning"]
              },
              {
                image: "/images/travel-safety.svg",
                title: "Safejani Travel Safety",
                description: "Route safety check app with real-time alerts and community updates",
                metrics: ["Safety Ratings", "News Feeds", "Community Posts", "Weather Alerts"]
              },
              {
                image: "/images/company-profiles.svg",
                title: "Company Websites",
                description: "Professional business websites with SEO optimization and high performance",
                metrics: ["5K+ Users", "SEO Optimized", "Fast Loading", "Mobile Responsive"]
              },
              {
                image: "/images/whatsapp-chatbot.svg",
                title: "WhatsApp Chatbots",
                description: "Automated customer support and business communication solutions",
                metrics: ["24/7 Support", "Auto Reply", "Integration", "Customer Service"]
              }
            ].map((solution, index) => (
              <div key={index} className="ms-glass-card p-6 ms-fade-in" style={{animationDelay: `${index * 0.1}s`}}>
                <div className="mb-6">
                  <img 
                    src={solution.image} 
                    alt={solution.title}
                    className="w-full h-48 object-cover rounded-lg shadow-lg bg-gray-100"
                    loading="lazy"
                    onError={(e) => {
                      const target = e.currentTarget as HTMLImageElement;
                      const fallback = target.nextElementSibling as HTMLElement;
                      target.style.display = 'none';
                      fallback.style.display = 'flex';
                    }}
                  />
                  <div className="w-full h-48 bg-gradient-to-br from-[#2a2d70] to-[#413988] rounded-lg shadow-lg flex items-center justify-center text-white font-semibold text-lg" style={{display: 'none'}}>
                    {solution.title}
                  </div>
                </div>
                <h3 className="ms-text-title mb-4 ms-gradient-text-secondary">{solution.title}</h3>
                <p className="ms-text-body mb-6">{solution.description}</p>
                <div className="space-y-2">
                  {solution.metrics.map((metric, metricIndex) => (
                    <div key={metricIndex} className="flex items-center">
                      <div className="w-2 h-2 bg-[#2a2d70] rounded-full mr-3 flex-shrink-0"></div>
                      <span className="ms-text-body text-gray-600">{metric}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
          
          <div className="text-center mt-16 ms-fade-in">
            <button 
              onClick={() => setIsProjectFormOpen(true)}
              className="ms-btn-primary ms-btn-large"
            >
              Start Your Project
              <FontAwesomeIcon icon={["fas","arrow-right"]} className="ml-2 h-4 w-4" />
            </button>
          </div>
        </div>
      </section>

      {/* Microsoft About Section */}
      <section id="about" className="ms-section ms-hero-bg">
        <div className="ms-container">
          <div className="ms-grid-2 gap-16 items-center">
            <div className="ms-slide-up">
              <div className="ms-badge ms-badge-primary mb-6">
                <FontAwesomeIcon icon={["fas","shield"]} className="h-4 w-4 mr-2" />
                About Us
              </div>
              <h2 className="ms-text-hero text-white mb-6 ms-gradient-text-primary drop-shadow-[0_3px_8px_rgba(0,0,0,0.45)]">
                Pioneering Technology Innovation in South Sudan
              </h2>
              <p className="ms-text-subtitle text-white mb-8 drop-shadow-[0_2px_6px_rgba(0,0,0,0.6)]">
                We believe in the power of technology to transform businesses and communities. 
                Our team combines deep technical expertise with local market understanding to deliver 
                solutions that drive real impact.
              </p>
              <div className="space-y-4 mb-8">
                <div className="flex items-center text-white drop-shadow-[0_2px_6px_rgba(0,0,0,0.6)]">
                  <CheckCircle className="h-5 w-5 mr-3 text-[#2a2d70]" />
                  <span>Cutting-edge technology solutions</span>
                </div>
                <div className="flex items-center text-white drop-shadow-[0_2px_6px_rgba(0,0,0,0.6)]">
                  <CheckCircle className="h-5 w-5 mr-3 text-[#2a2d70]" />
                  <span>Local expertise, global standards</span>
                </div>
                <div className="flex items-center text-white drop-shadow-[0_2px_6px_rgba(0,0,0,0.6)]">
                  <CheckCircle className="h-5 w-5 mr-3 text-[#2a2d70]" />
                  <span>Dedicated support and maintenance</span>
                </div>
              </div>
              <button 
                onClick={() => setIsProjectFormOpen(true)}
                className="ms-btn-secondary ms-btn-large text-white border-white hover:bg-white hover:text-[#2a2d70] shadow-lg"
              >
                Learn About Our Process
                <FontAwesomeIcon icon={["fas","arrow-right"]} className="ml-2 h-4 w-4" />
              </button>
            </div>
            
            <div className="ms-float">
              <div className="ms-glass-card p-8">
                <div className="space-y-6">
                  <div className="flex items-center">
                    <div className="ms-icon ms-icon-primary mr-4" aria-hidden="true">
                      <FontAwesomeIcon icon={["fas","lightbulb"]} className="h-5 w-5" />
                    </div>
                    <div>
                      <h4 className="ms-text-title ms-gradient-text-success">Innovation First</h4>
                      <p className="ms-text-body">Embracing cutting-edge technologies</p>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <div className="ms-icon ms-icon-primary mr-4" aria-hidden="true">
                      <FontAwesomeIcon icon={["fas","users"]} className="h-5 w-5" />
                    </div>
                    <div>
                      <h4 className="ms-text-title ms-gradient-text-accent">Client-Focused</h4>
                      <p className="ms-text-body">Your success is our priority</p>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <div className="ms-icon ms-icon-primary mr-4" aria-hidden="true">
                      <FontAwesomeIcon icon={["fas","shield"]} className="h-5 w-5" />
                    </div>
                    <div>
                      <h4 className="ms-text-title ms-gradient-text-warning">Reliable & Secure</h4>
                      <p className="ms-text-body">Built with security and reliability in mind</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Microsoft Team Section */}
      <section id="team" className="ms-section ms-surface">
        <div className="ms-container">
          <div className="text-center mb-16 ms-fade-in">
            <div className="ms-badge ms-badge-primary mb-6">
              <Users className="h-4 w-4 mr-2" />
              Our Team
            </div>
            <h2 className="ms-text-hero mb-6 ms-gradient-text-success">
              Meet the Experts Behind Your Success
            </h2>
            <p className="ms-text-subtitle max-w-3xl mx-auto">
              Our passionate team of developers and technology experts is dedicated to bringing your vision to life.
            </p>
          </div>
          
          <div className="ms-grid-3 max-w-4xl mx-auto">
            <div className="ms-glass-card text-center p-8 ms-fade-in">
              <div className="relative mb-6">
                <img 
                  src="/images/johnmarit.JPG" 
                  alt="John Marit - Lead Developer"
                  className="w-24 h-24 rounded-full mx-auto mb-4 object-cover shadow-lg"
                  loading="lazy"
                />
              </div>
              <h3 className="ms-text-title mb-2 ms-gradient-text-primary">John Marit</h3>
              <p className="ms-text-body mb-4">Lead Developer</p>
              <p className="ms-text-caption mb-4">
                Full-stack developer with expertise in modern web technologies and system architecture.
              </p>
              <div className="flex justify-center space-x-3">
                <a href="https://www.linkedin.com/in/john-marit?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app" target="_blank" rel="noopener noreferrer" className="text-[#2a2d70] hover:text-[#191348] transition-colors" aria-label="LinkedIn profile">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
                <a href="https://x.com/john_marit_?s=21" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-800 transition-colors">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </a>
              </div>
            </div>
            
            <div className="ms-glass-card text-center p-8 ms-fade-in" style={{animationDelay: '0.1s'}}>
              <div className="relative mb-6">
                <img 
                  src="/images/AdumThuc.jpg" 
                  alt="Adum Thuc - Software Developer"
                  className="w-24 h-24 rounded-full mx-auto mb-4 object-cover shadow-lg"
                  loading="lazy"
                />
              </div>
              <h3 className="ms-text-title mb-2 ms-gradient-text-secondary">Adum Thuc</h3>
              <p className="ms-text-body mb-4">Software Developer</p>
              <p className="ms-text-caption mb-4">
                Specialized in mobile development and user experience design with a focus on performance.
              </p>
              <div className="flex justify-center space-x-3">
                <a href="https://www.linkedin.com/in/adum-thuc-b194b0217/" target="_blank" rel="noopener noreferrer" className="text-[#2a2d70] hover:text-[#191348] transition-colors" aria-label="LinkedIn profile">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
                <a href="https://x.com/Ayameraau" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-800 transition-colors">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </a>
              </div>
            </div>
            
            <div className="ms-glass-card text-center p-8 ms-fade-in" style={{animationDelay: '0.2s'}}>
              <div className="relative mb-6">
                <img 
                  src="/images/BuayMattit.jpg" 
                  alt="Buay John - Software Developer"
                  className="w-24 h-24 rounded-full mx-auto mb-4 object-cover shadow-lg"
                  loading="lazy"
                />
              </div>
              <h3 className="ms-text-title mb-2 ms-gradient-text-accent">Buay John</h3>
              <p className="ms-text-body mb-4">Software Developer</p>
              <p className="ms-text-caption mb-4">
                Expert in web development and database management with a passion for clean, efficient code.
              </p>
              <div className="flex justify-center space-x-3">
                <a href="https://www.linkedin.com/in/buay-john-40b309b8/" target="_blank" rel="noopener noreferrer" className="text-[#2a2d70] hover:text-[#191348] transition-colors" aria-label="LinkedIn profile">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                  </svg>
                </a>
                <a href="https://x.com/buaymattit" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-800 transition-colors">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                  </svg>
                </a>
              </div>
            </div>
          </div>
          
          <div className="text-center mt-16 ms-fade-in">
            <div className="ms-glass-card p-8 max-w-3xl mx-auto">
              <h3 className="ms-text-title mb-4 ms-gradient-text-success">Our Development Philosophy</h3>
              <p className="ms-text-body mb-6">
                We believe in clean code, innovative solutions, and delivering high-quality software 
                that makes a real difference in our clients' businesses and communities.
              </p>
              <button 
                onClick={() => setIsProjectFormOpen(true)}
                className="ms-btn-secondary"
              >
                Learn About Our Process
                <FontAwesomeIcon icon={["fas","arrow-right"]} className="ml-2 h-4 w-4" />
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Microsoft Contact Section */}
      <section id="contact" className="ms-section ms-surface-1">
        <div className="ms-container">
          <div className="text-center mb-16 ms-fade-in">
            <div className="ms-badge ms-badge-primary mb-6">
                <FontAwesomeIcon icon={["fas","envelope"]} className="h-4 w-4 mr-2" />
              Get In Touch
            </div>
            <h2 className="ms-text-hero mb-6 ms-gradient-text-warning">
              Ready to Transform Your Business?
            </h2>
            <p className="ms-text-subtitle max-w-3xl mx-auto">
              Let's discuss how we can help you achieve your technology goals and drive your business forward.
            </p>
          </div>
          
          <div className="ms-grid-3 mb-16">
            <div className="text-center ms-fade-in">
              <div className="ms-icon ms-icon-primary mx-auto mb-4" aria-hidden="true">
                <FontAwesomeIcon icon={["fas","envelope"]} className="h-6 w-6" />
              </div>
              <h3 className="ms-text-title mb-3">Email Us</h3>
              <p className="ms-text-body mb-4">Get in touch via email</p>
              <a href="mailto:info@belednai.com" className="text-[#2a2d70] hover:text-[#191348] font-medium">
                info@belednai.com
              </a>
            </div>
            
            <div className="text-center ms-fade-in" style={{animationDelay: '0.1s'}}>
              <div className="ms-icon ms-icon-primary mx-auto mb-4" aria-hidden="true">
                <FontAwesomeIcon icon={["fas","phone"]} className="h-6 w-6" />
              </div>
              <h3 className="ms-text-title mb-3">Call Us</h3>
              <p className="ms-text-body mb-4">Speak with our team</p>
              <a href="tel:+211928446544" className="text-[#2a2d70] hover:text-[#191348] font-medium">
                +211 928 446 544
              </a>
            </div>
            
            <div className="text-center ms-fade-in" style={{animationDelay: '0.2s'}}>
              <div className="ms-icon ms-icon-primary mx-auto mb-4" aria-hidden="true">
                <FontAwesomeIcon icon={["fas","map-marker-alt"]} className="h-6 w-6" />
              </div>
              <h3 className="ms-text-title mb-3">Visit Us</h3>
              <p className="ms-text-body mb-4">Come see us in person</p>
              <span className="text-[#2a2d70] font-medium">Juba, South Sudan</span>
            </div>
          </div>
          
          <div className="text-center space-y-4 sm:space-y-0 sm:flex sm:justify-center sm:space-x-4 ms-fade-in">
            <button 
              onClick={() => setIsProjectFormOpen(true)}
              className="ms-btn-primary ms-btn-large"
            >
            Start Your Project
              <ArrowRight className="ml-2 h-4 w-4" />
            </button>
            <button 
              onClick={() => setIsProjectFormOpen(true)}
              className="ms-btn-secondary ms-btn-large"
            >
            Schedule Consultation
            </button>
          </div>
        </div>
      </section>

      {/* Microsoft Footer */}
      <footer className="ms-section bg-gray-900 text-white">
        <div className="ms-container">
          <div className="ms-grid-4 mb-12">
            <div className="space-y-4">
              <div className="flex items-center space-x-3 mb-6">
                <div className="flex items-center justify-center w-8 h-8">
                  <img 
                    src="/logo.png" 
                    alt="Belednai Technology Logo"
                    className="w-8 h-8"
                  />
                </div>
            <div>
                  <h3 className="text-lg font-semibold ms-gradient-text-primary">Belednai Technology</h3>
                  <p className="text-sm text-gray-300">Inventing the Unseen</p>
                </div>
              </div>
              <p className="text-sm text-gray-300 leading-relaxed">
                Empowering businesses through innovative technology solutions and expert development services.
              </p>
            </div>
            
            <div>
              <h4 className="text-white font-semibold mb-4 text-base">Services</h4>
              <ul className="space-y-3 text-sm text-gray-300">
                <li><a href="#" className="hover:text-white hover:text-[#2a2d70] transition-colors duration-200">Website Development</a></li>
                <li><a href="#" className="hover:text-white hover:text-[#2a2d70] transition-colors duration-200">Custom Software</a></li>
                <li><a href="#" className="hover:text-white hover:text-[#2a2d70] transition-colors duration-200">Email Solutions</a></li>
                <li><a href="#" className="hover:text-white hover:text-[#2a2d70] transition-colors duration-200">Mobile Apps</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-white font-semibold mb-4 text-base">Company</h4>
              <ul className="space-y-3 text-sm text-gray-300">
                <li><a href="#" className="hover:text-white hover:text-[#2a2d70] transition-colors duration-200">About Us</a></li>
                <li><a href="#" className="hover:text-white hover:text-[#2a2d70] transition-colors duration-200">Our Team</a></li>
                <li><a href="#" className="hover:text-white hover:text-[#2a2d70] transition-colors duration-200">Success Stories</a></li>
                <li><a href="#" className="hover:text-white hover:text-[#2a2d70] transition-colors duration-200">Contact</a></li>
              </ul>
            </div>
            
            <div>
              <h4 className="text-white font-semibold mb-4 text-base">Connect</h4>
              <p className="text-sm text-gray-300 mb-4 leading-relaxed">
                Stay updated with our latest projects and insights.
              </p>
              <div className="flex space-x-4">
                 <a href="#" className="text-gray-300 hover:text-white transition-colors duration-200" aria-label="Email">
                  <FontAwesomeIcon icon={["fas","envelope"]} className="h-5 w-5" />
                </a>
                <a href="#" className="text-gray-300 hover:text-white transition-colors duration-200" aria-label="Website">
                  <FontAwesomeIcon icon={["fas","globe"]} className="h-5 w-5" />
                </a>
              </div>
            </div>
          </div>
          
          <div className="border-t border-gray-700 pt-8 text-center">
            <p className="text-sm text-gray-300 font-medium">
              © 2025 Belednai Technology. All rights reserved.
            </p>
          </div>
        </div>
      </footer>

      {/* Project Form Modal */}
      <Dialog open={isProjectFormOpen} onOpenChange={setIsProjectFormOpen}>
        <DialogContent className="sm:max-w-[420px] max-h-[90vh] overflow-y-auto bg-white border-0 shadow-2xl rounded-lg p-6 data-[state=open]:bg-white">
          <div className="mb-6">
            <h2 className="text-xl font-semibold text-[#2a2d70] mb-2">Start Your Project</h2>
            <p className="text-gray-600 text-sm">
              Tell us about your project and we'll get back to you within 24 hours.
            </p>
          </div>
          
          <form 
            className="space-y-5" 
            action="https://formspree.io/f/xzzvzbvn"
            method="POST"
            onSubmit={(e) => {
              e.preventDefault();
              const form = e.target as HTMLFormElement;
              const formData = new FormData(form);
              
              fetch(form.action, {
                method: 'POST',
                body: formData,
                headers: {
                  'Accept': 'application/json'
                }
              })
              .then(response => {
                if (response.ok) {
                  alert('Message sent successfully!');
                  setIsProjectFormOpen(false);
                  form.reset();
                } else {
                  throw new Error('Failed to send message');
                }
              })
              .catch(error => {
                console.error('Error:', error);
                alert('Failed to send message. Please try again.');
              });
            }}
          >
            <input type="hidden" name="_subject" value="New Project Request - Belednai Technology" />
            <input type="hidden" name="_from" value="Belednai Technology Website" />
            <input type="hidden" name="_template" value="table" />
            <input type="hidden" name="_reply-to" value="belednai24@gmail.com" />
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div>
                <Input 
                  id="name" 
                  name="name"
                  placeholder="Name *" 
                  required 
                   className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-1 focus:ring-[#2a2d70] focus:border-[#2a2d70] hover:border-[#2a2d70] transition-all duration-200 bg-white text-sm text-[#2a2d70] placeholder:text-[#2a2d70]/60"
                />
              </div>
              
              <div>
                <Input 
                  id="email" 
                  name="email"
                  type="email" 
                  placeholder="Email *" 
                  required 
                   className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-1 focus:ring-[#2a2d70] focus:border-[#2a2d70] hover:border-[#2a2d70] transition-all duration-200 bg-white text-sm text-[#2a2d70] placeholder:text-[#2a2d70]/60"
                />
              </div>
              
              <div>
                <Input 
                  id="number" 
                  name="number"
                  type="tel" 
                  placeholder="Number *" 
                  required 
                   className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-1 focus:ring-[#2a2d70] focus:border-[#2a2d70] hover:border-[#2a2d70] transition-all duration-200 bg-white text-sm text-[#2a2d70] placeholder:text-[#2a2d70]/60"
                />
              </div>
            </div>
            
            <div>
              <Textarea 
                id="message" 
                name="message"
                placeholder="Tell us about your project... *" 
                rows={3}
                required
                className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-1 focus:ring-[#2a2d70] focus:border-[#2a2d70] hover:border-[#2a2d70] transition-all duration-200 bg-white text-sm resize-none text-[#2a2d70] placeholder:text-[#2a2d70]/60"
              />
            </div>
            
            <div className="flex gap-3 pt-2">
              <Button 
                type="button" 
                variant="outline" 
                onClick={() => setIsProjectFormOpen(false)}
                className="flex-1 border-[#2a2d70] text-[#2a2d70] bg-white hover:bg-[#2a2d70]/5 hover:text-[#2a2d70] hover:border-[#2a2d70] transition-all duration-200 rounded-lg py-2 text-sm font-medium"
              >
                Cancel
              </Button>
              <Button 
                type="submit" 
                className="flex-1 bg-[#2a2d70] hover:bg-[#1a1a4a] text-white rounded-lg transition-all duration-200 py-2 text-sm font-medium"
              >
                Send Message
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Index;
